import { useState } from "react";
import FinancialModelAWS from "../../stacks/financialModel/FinancialModelAWS";

export const useAddScenario = (body,cb) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [data, setData] = useState({});

  async function refetch() {
    setLoading(true);
    try {
      const financialModelApi = FinancialModelAWS.getInstance();
      const fin = await financialModelApi.createForecast(body);
      setData(fin);
      setError("");
      setLoading(false);
      cb && cb();
    } catch (err) {
      console.log(`ERROR adding forecasts ${err.message}`);
      setError(err.message);
      setLoading(false);
    }
  }

  return [{ loading, error, data }, refetch];
};

// async function add() {
//   try {
//     setResult(undefined)
//     setLoading(true)
//     setErrorMsg('')
//     const financialModelApi = FinancialModel.getInstance();
//     const fin = await financialModelApi.createForcast({"name": line})
//     setResult(fin)
//     setLoading(false)
//     retrieve()
//   }
//   catch (err) {
//     console.log(`ERROR adding forecasts ${err.message}`)
//     setErrorMsg(err.message)
//     setLoading(false)
//   }
// }